import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IOnboardingStatsPayloadState extends ISagaCb {
    eventId: string
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const onboardingStatsSlice = createSlice({
    name: 'company-statistics/onboarding-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOnboardingStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const onboardingStatsActions = onboardingStatsSlice.actions
export default onboardingStatsSlice.reducer
